// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"9":"d8db097e","133":"02888258","601":"379747ed","850":"02c440b9","851":"4b4c99a7","926":"ae9256e5","948":"9e407bb4"}[chunkId] + ".js";
};